import axios from "axios"
import {format} from "date-fns"

const init = () => {

	const loadingClass           = 'is-loading'
	const step                   = document.querySelector('[data-booking-step]')
	const overviewContainer      = step.querySelector('[data-overview-container]')
	const overviewContainerInner = step.querySelector('[data-overview-container-inner]')
	let   addDonation            = 'no'

	for (const radioBtn of step.querySelectorAll('[data-donate] input')) {

		radioBtn.addEventListener('change', (e) => {
			addDonation = e.target.value
			getOverview()
		})
	}

	const getOverview = () => {
		
		overviewContainer.classList.add(loadingClass)

		const formData = new FormData()
		formData.append(window.csrfTokenName, window.csrfTokenValue)

		const url = new URL('/data/donate-overview', window.location.origin)

		// Url params
		url.searchParams.append('add-donation', addDonation) // Param to show if donation should be added
		url.searchParams.append('cachebust', format(new Date(), 't')) // Cachebust param
		
		// Ajax call
		axios
			.post(url.href, formData)
			.then((response) => {
				// console.log(response)
				overviewContainerInner.innerHTML = response.data.html
				overviewContainer.classList.remove(loadingClass)
			})
	}

	getOverview()
}

export default function() {
    init();
}